import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'ngx-owl-carousel-o';

import { PagesRoutingModule } from './pages-routing.module';
import { SharedModule } from '../shared/shared.module'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { PagesComponent } from './pages.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PrivacyPolicyComponent } from '../customs/privacy-policy/privacy-policy.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    PagesComponent, 
    PageNotFoundComponent,
    PrivacyPolicyComponent,
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    SharedModule,
    CarouselModule,
    NgbModule,
    TranslateModule,
  ],
  exports: [
    PageNotFoundComponent
  ]
})
export class PagesModule { }
